import React from 'react';

const Discussion = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="m16.441 8.0586c-1.4519-0.038851-2.9351 0.098312-4.3867 0.42383-2.9032 0.65103-5.2441 1.9776-6.7188 3.7148s-2.0553 3.9398-1.3379 6.082 2.5458 3.8497 4.9062 4.9688c2.3605 1.119 5.2788 1.6635 8.3145 1.4375l-0.105-1.416c-2.798 0.209-5.489-0.306-7.5993-1.306-2.1108-1.001-3.6135-2.473-4.1699-4.135-0.5565-1.662-0.1484-3.275 1.0742-4.715 1.2225-1.44 3.289-2.652 5.947-3.2478 5.317-1.1922 11.158 0.5618 13.369 3.7378 1.1057 1.5885 1.2011 3.2073 0.48828 4.7422-0.71285 1.5348-2.3047 2.9854-4.6934 3.9355l0.52539 1.3184c2.6467-1.0528 4.5492-2.7058 5.4551-4.6562 0.90588-1.9505 0.74519-4.2015-0.61133-6.1504-2.034-2.9224-6.101-4.6189-10.457-4.7354z" />
    <path
      d="m22.504 21.855-1.291 0.58789c0.97997 2.1572 2.0587 3.3344 3.1582 4.3027-1.6778-0.02286-3.2086-0.25003-4.3594-0.75977-1.5678-0.69449-2.5457-1.7177-2.8438-2.6055l-1.3438 0.45117c0.47753 1.4223 1.7841 2.6409 3.6133 3.4512 1.8291 0.81025 4.2083 1.2067 6.9355 0.875l1.809-0.219-1.481-1.061c-1.5946-1.1424-2.8716-2.1033-4.1973-5.0215z"
      fillRule="evenodd"
    />
  </svg>
);

export default Discussion;
